import React, { useEffect, useRef, useState } from "react";

// The blog's Copy link button. It says how that went right where someone clicked, then goes back.
const SHOWN_MS = 2000;

// navigator.clipboard is missing on a page not served over https, and a browser can refuse it.
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const box = document.createElement("textarea");
    box.value = text;
    box.setAttribute("readonly", "");
    box.style.position = "fixed";
    box.style.opacity = "0";
    document.body.appendChild(box);
    box.select();
    try {
      return document.execCommand("copy");
    } catch {
      return false;
    } finally {
      box.remove();
    }
  }
}

function ShareIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M18 8a3 3 0 1 0-2.8-1.9L8.9 9.1a3 3 0 0 0 0 5.8l6.3 3.1A3 3 0 1 0 16 16a3 3 0 0 0-.2 0l-6.3-3.1a3 3 0 0 0 0-1.8l6.3-3.1c.2 0 .4 0 .6 0z"
      />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  );
}

export default function CopyLinkButton({ url }) {
  const [outcome, setOutcome] = useState(null); // null | "copied" | "failed"
  const timer = useRef(0);
  useEffect(() => () => clearTimeout(timer.current), []);

  async function copy() {
    const copied = await copyToClipboard(url);
    setOutcome(copied ? "copied" : "failed");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setOutcome(null), SHOWN_MS);
  }

  return (
    <span className="copyLink">
      <button
        type="button"
        aria-label="Copy link"
        title="Copy link"
        className={outcome === "copied" ? "isCopied" : undefined}
        onClick={copy}
      >
        {outcome === "copied" ? <CheckIcon /> : <ShareIcon />}
      </button>
      <span className="copyLink__note" role="status">
        {outcome === "copied" ? "Link copied" : outcome === "failed" ? "Couldn't copy the link" : ""}
      </span>
    </span>
  );
}
